import { FormControl, FormLabel, Input, FormErrorMessage, Flex, Select } from "@chakra-ui/react"
import { Formik, Field, FieldProps } from "formik"
import { Dispatch, SetStateAction } from "react"
import { AutoSubmitter } from "./AutoSubmitter"

const validateDinoNumber = (dinoNumber: string) => {
    const minDino = 0
    const maxDino = 9996

    let error;
    if (isNaN(parseInt(dinoNumber))) {
        error = "Enter only the numerical value, i.e. 8024, for Dino Number."
    } else if (parseInt(dinoNumber) < minDino || parseInt(dinoNumber) > maxDino) {
        error = "The Dino Number entered does not exist."
    }
    return error
}

type DinoBuilderProps = {
    setDinoNumber: Dispatch<SetStateAction<string>>,
    setDinoType: Dispatch<SetStateAction<string>>,
    mode: string
}

export type DinoCreatorFormValues = {
    dinoNumberEntry: string;
    dinoType: string;
}



export const DinoCreatorForm: React.FC<DinoBuilderProps> = ({ setDinoNumber, setDinoType, mode }) => {

    return (
        <Flex flexDir='column'>
            <Formik
                initialValues={{
                    dinoNumberEntry: '8209',
                    dinoType: 'og'
                }}
                onSubmit={(values) => {
                    console.log("Submitting: ", values.dinoNumberEntry, values.dinoType)
                    setDinoNumber(values.dinoNumberEntry)
                    setDinoType(values.dinoType)
                }}
            >
                {({ handleSubmit, errors, touched }) => (
                    <form onSubmit={handleSubmit}>
                        <FormControl isInvalid={!!errors.dinoNumberEntry && touched.dinoNumberEntry}>
                            <FormLabel htmlFor="dinoNumberEntry" textColor='white' >Enter Dino Number</FormLabel>
                            <Field
                                as={Input}
                                id="dinoNumberEntry"
                                name="dinoNumberEntry"
                                placeholder="8209"
                                bgColor='white'
                                maxW='400px'
                                validate={validateDinoNumber}
                            />
                            <FormErrorMessage>{errors.dinoNumberEntry}</FormErrorMessage>
                        </FormControl>

                        <FormControl marginBottom='2vh'>
                            <FormLabel htmlFor="dinoType" textColor='white'>Which Collection?</FormLabel>
                            <Field>
                            {({ field }: FieldProps) => (
                                <Select
                                    id="dinoType"
                                    name="dinoType"
                                    onChange={field.onChange}
                                    bgColor='white'
                                    maxW='400px'>

                                    <option value='og'>Dapper Dinos NFT (Original)</option>
                                    <option value='karma'>Karma Collective</option>
                                </Select>
                            )}    
                            </Field>
                        </FormControl>
                        <AutoSubmitter />
                    </form>
                )}

            </Formik>
        </Flex>
    )
}

